import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Vuex from 'vuex';
import { getAllEnumType, GetCustomerSourceList, GetImportDepartment, QueryCustomerAptitudeLevel, UploadFile, GetFile, GetDeptTree, GetChildDeptAndAllPerson, QueryFeedback, ReplyFeedback } from "../api/common";
import user from './module/user';
import app from './module/app';
import { traversingTree, getDeptTreeData } from '@/libs/util';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    name: 'main-app',
    //
    wh: {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight
    },
    AllEnumType: {},
    // 所有枚举类型
    // 客户来源option
    clientFrom: [],
    ImportDepartDataList: [],
    // 导入部门列表
    // 客户标签
    QueryCustomerAptitudeLevel: [],
    messageQueue: [],
    //消息列表
    followAllowTime: 0,
    //可允许的跟进时间
    addDeptTree: [],
    //组织树
    echartResize: false
  },
  mutations: {
    /**
     * 添加一个消息列表
     * @param state
     * @param key
     * @param name
     */
    setMessageQueue: function setMessageQueue(state, _ref) {
      var key = _ref.key,
          name = _ref.name;
      var temp = false;
      var index = 0;

      for (var i = 0; i < state.messageQueue.length; i++) {
        var list = state.messageQueue[i];

        if (key == list.key) {
          temp = true;
          index = i;
          break;
        }
      }

      if (temp) {
        state.messageQueue[index].number = state.messageQueue[index].number++;
      } else {
        state.messageQueue.push({
          key: key,
          name: name,
          number: 1
        });
      }
    },

    /**
     * 删除一条队列消息
     * @param state
     * @param key
     */
    delMessageQueue: function delMessageQueue(state, key) {
      for (var i in state.messageQueue) {
        var list = state.messageQueue[i];

        if (key == list.key) {
          state.messageQueue.splice(i, 1);
        }
      }
    },
    //
    windowResize: function windowResize(state, wh) {
      state.wh.innerWidth = wh.innerWidth;
      state.wh.innerHeight = wh.innerHeight;
    },
    setAllEnumType: function setAllEnumType(state, data) {
      var obj = {};

      if (Array.isArray(data) && data.length > 0) {
        data.forEach(function (item) {
          obj[item.enumTypeCode] = item.enumValue;
        });
      }

      state.AllEnumType = obj;
    },
    // 设置客户来源
    setclientFrom: function setclientFrom(state, res) {
      if (res != undefined && Array.isArray(res) && res.length > 0) {
        state.clientFrom = res;
      }
    },
    // 设置导入部门数据 列表
    setImportDepartDataList: function setImportDepartDataList(state, data) {
      //;
      state.DepartDataListSource = data;

      if (Array.isArray(data) && data.length > 0) {
        state.ImportDepartDataList = traversingTree(data, '0');
      }
    },
    setQueryCustomerAptitudeLevel: function setQueryCustomerAptitudeLevel(state, data) {
      state.QueryCustomerAptitudeLevel = data;
    },

    /**
     * 获取配置项值
     * @param state
     * @param day
     */
    setfollowAllowTime: function setfollowAllowTime(state, day) {
      state.followAllowTime = day;
    },

    /**
     * 设置级联树
     * @param state
     * @param data
     */
    setDeptTree: function setDeptTree(state, data) {
      var type = Object.prototype.toString.call(data);
      var arr = [];

      if (type == '[object Object]') {
        arr.push({
          value: data.deptID,
          label: data.deptName
        });
        arr[0].children = getDeptTreeData(data.childDept);
      } else if (type == '[object Array]') {}

      state.addDeptTree = arr;
    },
    echartDomResize: function echartDomResize(state, b) {
      state.echartResize = b;
    }
  },
  actions: {
    //
    // 获取所有枚举类型
    handelGetAllEnumType: function handelGetAllEnumType(_ref2, params) {
      var commit = _ref2.commit;
      return new Promise(function (resolve, reject) {
        getAllEnumType(params).then(function (res) {
          if (res.status === 0) {
            commit('setAllEnumType', res.data);
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 获取客户来源
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handelGetClientFrom: function handelGetClientFrom(_ref3, params) {
      var commit = _ref3.commit;
      return new Promise(function (resolve, reject) {
        GetCustomerSourceList(params).then(function (res) {
          if (res.status === 0) {
            commit('setclientFrom', res.data);
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 获取可导入客户部门列表
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handelGetImportDepartment: function handelGetImportDepartment(_ref4, params) {
      var commit = _ref4.commit;
      return new Promise(function (resolve, reject) {
        GetImportDepartment(params).then(function (res) {
          if (res.status === 0) {
            commit('setImportDepartDataList', res.data);
            var reData = traversingTree(res.data, '0');
            resolve(reData);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 获取客户资质标签数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handelgetQueryCustomerAptitudeLevel: function handelgetQueryCustomerAptitudeLevel(_ref5, params) {
      var commit = _ref5.commit;
      return new Promise(function (resolve, reject) {
        QueryCustomerAptitudeLevel(params).then(function (res) {
          if (res.status === 0) {
            commit('setQueryCustomerAptitudeLevel', res.data);
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     *上传文件
     * @param commit
     * @param params 请求参数 formDataObj对象
     * @param type crm hrm oa
     * @returns {Promise<any>}
     */
    handleUploadFile: function handleUploadFile(_ref6, _ref7) {
      var commit = _ref6.commit;
      var params = _ref7.params,
          type = _ref7.type;
      var serviceDirectoryIdList = {
        hrm: '1B045B1F-5EF5-4EAA-A812-4C2C47CA24F9',
        oa: 'E4629BAC-A8B7-4ADE-A8C6-034F2C4A017C',
        crm: 'E9DDC481-DB6B-4A60-9A61-F2081FC8C594'
      };
      var serviceDirectoryId = serviceDirectoryIdList[type];
      params.append('serviceDirectoryId', serviceDirectoryId);
      return new Promise(function (resolve, reject) {
        UploadFile(params).then(function (res) {
          if (res.status === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 获取文件
     * @param commit
     * @param params
     * @param type
     * @returns {Promise<any>}
     */
    handleGetFile: function handleGetFile(_ref8, params) {
      var commit = _ref8.commit;
      return new Promise(function (resolve, reject) {
        GetFile(params).then(function (res) {
          if (res.status === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 获取配置项
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleGetConfig: function handleGetConfig(_ref9, params) {
      var commit = _ref9.commit;
      return new Promise(function (resolve, reject) {
        config(params).then(function (res) {
          commit("setfollowAllowTime", res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 获得组织树
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleGetDeptTree: function handleGetDeptTree(_ref10, params) {
      var commit = _ref10.commit;
      return new Promise(function (resolve, reject) {
        GetDeptTree(params).then(function (res) {
          if (res.status === 0) {
            commit('setDeptTree', res.data);
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 根据部门Id 获取部门的下一级部门列表和部门及下属所有部门的人员信息
     * @param commit
     * @param params
     * @param callback
     */
    handleGetChildDeptAndAllPerson: function handleGetChildDeptAndAllPerson(_ref11, params) {
      var commit = _ref11.commit;
      return new Promise(function (resolve, reject) {
        GetChildDeptAndAllPerson(params).then(function (res) {
          if (res.status === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 添加反馈
     * @param commit
     * @param params
     * @param callback
     */
    handleAddFeedback: function handleAddFeedback(_ref12, params) {
      var commit = _ref12.commit;
      return new Promise(function (resolve, reject) {
        AddFeedback(params).then(function (res) {
          if (res.status === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 回复反馈
     * @param commit
     * @param params
     * @param callback
     */
    handleReplyFeedback: function handleReplyFeedback(_ref13, params) {
      var commit = _ref13.commit;
      return new Promise(function (resolve, reject) {
        ReplyFeedback(params).then(function (res) {
          if (res.status === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 查询反馈列表
     * @param commit
     * @param params
     * @param callback
     */
    handleQueryFeedback: function handleQueryFeedback(_ref14, params) {
      var commit = _ref14.commit;
      return new Promise(function (resolve, reject) {
        QueryFeedback(params).then(function (res) {
          if (res.status === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  },
  modules: {
    user: user,
    app: app
  }
});